import { render } from "./ProssingFour.vue?vue&type=template&id=4b5d4c1a&scoped=true"
import script from "./ProssingFour.vue?vue&type=script&lang=js"
export * from "./ProssingFour.vue?vue&type=script&lang=js"

import "./ProssingFour.vue?vue&type=style&index=0&id=4b5d4c1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5d4c1a"]])

export default __exports__